// This file is automatically generated. Do not edit manually.

import { Delivery } from "src/api/generated/erp/db/types/tables/delivery";
import { DeliveryPackageSource } from "src/api/generated/erp/delivery/model/deliveryPackageSource";
import { CargoDriver } from "src/api/generated/erp/db/types/tables/cargoDriver";
import { DeliveryView } from "src/api/generated/erp/db/types/tables/deliveryView";
import { DeliveryMethod } from "src/api/generated/erp/db/types/tables/deliveryMethod";
import { SiteView } from "src/api/generated/erp/db/types/tables/siteView";
import { TransportRoute } from "src/api/generated/erp/db/types/tables/transportRoute";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DeliveryEditApi {
	export async function getFormInitData(args: {
		siteId: number | null | undefined;
		deliveryId: number | null | undefined;
	}): Promise<DeliveryEditApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/getFormInitData",
			method: "POST",
			data: {
				siteId: args.siteId,
				deliveryId: args.deliveryId,
			},
		});
		return response as DeliveryEditApi_FormInitData;
	}

	export async function insert(args: {
		delivery: Delivery;
		connectToPackageSource?: DeliveryPackageSource | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/insert",
			method: "POST",
			data: {
				delivery: args.delivery,
				connectToPackageSource: args.connectToPackageSource,
			},
		});
		return response as number;
	}

	export async function update(args: { delivery: Delivery }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/update",
			method: "POST",
			data: {
				delivery: args.delivery,
			},
		});
		return response as void;
	}

	export async function delete_(args: { deliveryIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/delete",
			method: "POST",
			data: {
				deliveryIds: args.deliveryIds,
			},
		});
		return response as void;
	}
}

export interface DeliveryEditApi_FormInitData {
	cargoDriverOptions: Array<CargoDriver>;
	delivery: DeliveryView | null | undefined;
	deliveryMethodOptions: Array<DeliveryMethod>;
	site: SiteView;
	transportRouteOptions: Array<TransportRoute>;
}
